<template>
  <div>
    <panel title="Вывод средств">
      <template slot="beforeBody">
        <b-alert variant="success mb-0" class="rounded-0  bg-info text-white" show>
          <!-- BEGIN row -->
          <div class="row">
            <div class="col-12">
              Минимальная сумма вывода 50 руб. Время на зачисление 1-3 рабочих дня. Подтверждение выплат
              <a href="https://t.me/fastsmmpays" target="_blank"><b>здесь</b></a>
            </div>
          </div>
          <!-- END row -->
        </b-alert>
      </template>
      <!-- BEGIN panel -->
      <div class="card  border-0 mb-3">
        <div class="card-body">
          <validation-observer ref="form">
            <form v-on:submit="checkForm" method="GET" class="fs-13px">
              <div class="row">
                <legend>Вывод средств:</legend>
                <validation-provider #default="{ errors }" name="sum" rules="required|min_value:50|max_value:10000"
                  vid="sum">
                  <div class="row mb-15px">
                    <label class="form-label col-form-label col-md-3">Сумма вывода</label>
                    <div class="col-md-9">
                      <input type="text" v-model="data.sum" class="form-control fs-15px" id="floatingInput"
                        placeholder="">
                      <small v-show="!errors[0]">Сумма для вывода от
                        50 руб.</small>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </div>
                  </div>
                </validation-provider>


                <div class="row mb-3">
                  <label class="form-label col-form-label col-md-3">Способ вывода:</label>
                  <div class="col-md-9 pt-2">
                    <div class="form-check mb-2">
                      <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                        checked="" v-model="data.type" value="YMoney" @click="() => { this.data.wallet = '' }">
                      <label class="form-check-label" for="flexRadioDefault1">
                        <b>ЮMoney</b>: Комиссия 0%. Кошелек должен быть идентифицирован.

                      </label>
                    </div>
                    <!--<div class="form-check mb-2">
											<input class="form-check-input" type="radio" name="flexRadioDefault"
												id="flexRadioDefault2" v-model="data.type" value="QIWI"
												@click="() => { this.data.wallet = '+7' }">
											<label class="form-check-label" for="flexRadioDefault2">
												<b>QiWi</b>: Комиссия 0%. Кошелек должен быть идентифицирован.
											</label>
										</div>-->

                    <div class="form-check mb-2">
                      <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault3"
                        v-model="data.type" value="Payeer" @click="() => { this.data.wallet = 'P' }">
                      <label class="form-check-label" for="flexRadioDefault3">
                        <b><a target="_blank" href="https://payeer.com/025743225">Payeer.com</a></b>: Комиссия 0%.
                      </label>
                    </div>
                  </div>
                </div>


                <validation-provider #default="{ errors }" name="wallet" rules="required|min:6|max:18" vid="wallet">
                  <div class="row mb-15px">
                    <label class="form-label col-form-label col-md-3">Номер кошелька</label>
                    <div class="col-md-9">
                      <input type="text" v-model="data.wallet" class="form-control fs-15px" id="floatingInput"
                        placeholder="">
                      <small v-show="!errors[0]">Номер кошелька</small>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </div>
                  </div>
                </validation-provider>

                <div v-if="false && payouts.length > 0">

                  <div class="row mb-15px">
                    <label class="form-label col-form-label col-md-3"></label>
                    <div class="col-md-9">
                      <div class="alert alert-info">
                        <h4> Вы уже получали выплаты ранее.</h4>
                        Для следующей выплаты:
                        <ol>
                          <li>Сделайте скриншот вашей предыдущей выплаты</li>
                          <li>Отправьте скриншот в эту группу <a href="https://t.me/fastsmmpays"
                              target="_blank">https://t.me/fastsmmpays</a></li>
                          <li>Скопируйте ссылку на Ваш ответ в группе и вставьте в поле ниже. Ссылка должна быть вида
                            https://t.me/fastsmmpays/(число)</li>
                        </ol>
                      </div>
                    </div>
                  </div>

                  <validation-provider #default="{ errors }" name="link" rules="required|min:6|max:512" vid="wallet">
                    <div class="row mb-15px">
                      <label class="form-label col-form-label col-md-3">Ссылка на ответ</label>
                      <div class="col-md-9">
                        <input type="text" v-model="data.link" class="form-control fs-15px" id="floatingInput"
                          placeholder="https://t.me/fastsmmpays/(число)">
                        <small v-show="!errors[0]">Ссылка на ответ в группе</small>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </div>
                    </div>
                  </validation-provider>

                </div>

              </div>
              <div class="d-flex justify-content-center">
                <button @click="() => { this.data = { sum: 0, wallet: 0 } }"
                  class="btn btn-default w-100px me-3">Отмена</button>
                <button :disabled="loading" @click="checkForm()" class="btn btn-primary  btn-lg fs-14px w-120px">
                  <i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
                  <span v-show="!loading">Вывести</span>
                </button>
              </div>
            </form>
          </validation-observer>
        </div>



        <h3 class="pt-5 pb-2">Ваши выплаты:</h3>
        <div v-if="payouts.length" class="alert alert-info"> После добавления завяки на выплату ее необходимо
          подтвердить.
          Для этого пожалуйста проверьте вашу
          почту.</div>
        <vue-good-table :columns="columns_payouts" :rows="payouts" :lineNumbers="false"
          :search-options="{ enabled: true, placeholder: 'Поиск...' }" :paginationOptions="{
              enabled: true,
              nextLabel: '',
              prevLabel: '',
              rowsPerPageLabel: 'Строк',
              ofLabel: 'из',
              allLabel: 'Все',
            }">
          <div slot="emptystate">
            <div class="text-center">
              Нет выплат...
            </div>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'status'">
              <div v-html="props.formattedRow[props.column.field]"></div>

            </span>
            <span v-else-if="props.column.field == 'link'">
              <a v-if="props.formattedRow[props.column.field]" :href="props.formattedRow[props.column.field]"
                target="_blank">Ссылка</a>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
        <h5 class="pt-2"> Итого вам выплатили: {{ payouts_sum }}</h5>


        <h3 class="pt-5 pb-2">Все выплаты:</h3>
        <vue-good-table :columns="columns_payouts_all" :rows="payouts_all" :lineNumbers="false"
          :search-options="{ enabled: true, placeholder: 'Поиск...' }" :paginationOptions="{
              enabled: true,
              nextLabel: '',
              prevLabel: '',
              rowsPerPageLabel: 'Строк',
              ofLabel: 'из',
              allLabel: 'Все',
            }">
          <div slot="emptystate">
            <div class="text-center">
              Нет выплат...
            </div>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'status'">
              <div v-html="props.formattedRow[props.column.field]"></div>
            </span>
            <span v-else-if="props.column.field == 'link'">
              <a v-if="props.formattedRow[props.column.field]" :href="props.formattedRow[props.column.field]"
                target="_blank">Ссылка</a>
            </span>
            <span v-else-if="props.column.field == 'user.avatar'">
              <img onerror="javascript:this.src='/images/avatar/user.png'"
                :src="`/images/avatar/` + props.row.user.avatar" alt="" width="50" height="50" class="user-avatar">
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
        <h5 class="pt-2"> Итого всем пользователям выплатили: {{ payouts_all_sum }}</h5>


      </div>
      <!-- END panel -->
    </panel>
  </div>
</template>


<script>
import HTTP from "../http";
import {show_error, show_message} from "../message";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required, email, max, min, max_value, min_value} from 'vee-validate/dist/rules';
extend('required', required);
extend('email', email);
extend('min', min);
extend('max', max);
extend('max_value', max_value);
extend('min_value', min_value);


export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      loading: false,
      errors: null,
      title: null,
      data: {
        sum: 0,
        wallet: 0,
        type: 'YMoney',
        link: null
      },

      payouts: [],
      payouts_all: [],
      payouts_sum: 0,
      payouts_all_sum: 0,
      columns_payouts: [
        {
          label: 'Дата',
          field: 'created_at',
          width: '10%',
          thClass: 'align-middle text-center text-nowrap hide-993',
          tdClass: 'align-middle text-center text-nowrap hide-993'
        }, {
          label: 'Сумма',
          field: 'sum',
          width: '5%',
          thClass: 'align-middle text-center text-nowrap',
          tdClass: 'align-middle text-center text-nowrap'
        },
        {
          label: 'Кошелек',
          field: 'wallet',
          width: '10%',
          thClass: 'align-middle text-center text-nowrap hide-993',
          tdClass: 'align-middle text-center text-nowrap hide-993'
        },
        {
          label: 'Статус',
          field: 'status',
          type: 'string',
          width: '10%',
          tdClass: 'align-middle text-center text-nowrap',
          thClass: 'align-middle text-center text-nowrap'
        }, {
          label: 'Ссылка',
          field: 'link',
          type: 'string',
          width: '10%',
          tdClass: 'align-middle text-center hide-768',
          thClass: 'align-middle text-center  hide-768'
        }, {
          label: 'Комментарий',
          field: 'comment',
          type: 'string',
          tdClass: 'align-middle text-left hide-993',
          thClass: 'align-middle text-left hide-993'
        }],


      columns_payouts_all: [
        {
          label: '',
          field: 'user.avatar',
          width: '50px',
          tdClass: 'text-center hide-768',
          thClass: 'text-center hide-768'
        },
        {
          label: 'Имя',
          field: 'user.name',
          type: 'string',
          width: '10%',
          tdClass: 'align-middle text-left text-nowrap',
          thClass: 'align-middle text-left text-nowrap'
        },
        {
          label: 'Дата',
          field: 'created_at',
          width: '10%',
          thClass: 'align-middle text-center text-nowrap hide-993',
          tdClass: 'align-middle text-center text-nowrap hide-993'
        }, {
          label: 'Сумма',
          field: 'sum',
          width: '5%',
          thClass: 'align-middle text-center text-nowrap',
          tdClass: 'align-middle text-center text-nowrap'
        },
        {
          label: 'Статус',
          field: 'status',
          type: 'string',
          width: '10%',
          tdClass: 'align-middle text-center text-nowrap hide-768',
          thClass: 'align-middle text-center text-nowrap hide-768'
        }, {
          label: 'Ссылка',
          field: 'link',
          type: 'string',
          tdClass: 'align-middle text-left hide-768',
          thClass: 'align-middle text-left  hide-768'
        }],
    };
  },

  created() {
    this.fetchData()
  },

  methods: {
    checkForm: function () {
      this.$refs.form.validate().then(success => {
        //e.preventDefault();
        if (!success) {
          return;
        }
        this.$insProgress.start();
        this.loading = true;
        HTTP()
          .post("/payout", this.data)
          .then((resp) => {
            console.log(resp)
            show_message(
              this.$notify,
              resp.data
            );
            this.data = {
              sum: 0,
              wallet: 0,
            }
            setTimeout(() => {this.fetchData()}, 500);

          })
          .catch((error) => {
            show_error(this.$notify, this.$refs.form, error.response.data)
          })
          .finally(() => {
            this.loading = false;
            this.$insProgress.finish();
          });
      })
    },
    fetchData() {
      this.loading = true;
      this.$insProgress.start();

      HTTP()
        .get(`/payout`)
        .then((resp) => {
          console.log('resp', resp)
          this.payouts = resp.data.payouts;
          this.payouts_all = resp.data.payouts_all;
          this.payouts_sum = resp.data.payouts_sum;
          this.payouts_all_sum = resp.data.payouts_all_sum;
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },

  }
}

</script>


<style>
.task-href {
  cursor: pointer;
  text-decoration: none;
  color: var(--bs-body-color);
}

.task-href:visited {
  color: var(--bs-body-color);
}

.task-href:hover {
  color: var(--bs-body-color);
}
</style>
